import './AccessData.scss';

import React, { useCallback, useEffect, useState } from 'react';
import { PersonalDataSummary } from '../../fields/PersonalDataSummary/PersonalDataSummary';
import { Section } from '../../Section/Section';
import { Password } from '../../fields/Password/Password';
import { SECTION_TYPE } from '../../constants';
import {
    doTagClickStartButton,
    doTagIsValidAndGoNext,
    doTagModifyIdDocument,
    doTagObscurePassword,
    doTagPassword,
    doTagPasswordErrors,
} from './tagging';
import { useAccessDataReset } from 'components/newAccountSteps/initialStep/sections/AccessData/hooks/useAccessDataReset';

const SECTION_FIELDS = ['password'];

export const AccessData = ({
    formActions,
    handleModifySection,
    handleModifyID,
    handleValidateSection,
    isCollapsed,
    isValidated,
    promoCode,
    userProfile,
    userProfileForm,
    renderTermsAndConditions,
}) => {
    const { docNumber, documentType } = userProfile;
    const [isValidPass, setIsValidPass] = useState(false);

    useAccessDataReset({
        setIsValidPass,
        onboardingType: userProfile.onboardingType,
    });

    useEffect(() => {
        isCollapsed && formActions.setValidity('userProfile.password', { required: true });
    }, [isCollapsed]);

    const areAllFieldsFilled = () => {
        return SECTION_FIELDS.every(field => userProfile[field]);
    };

    const isButtonDisabled = !areAllFieldsFilled() || !userProfileForm.$form.valid || !isValidPass;

    const onValidationSection = () => {
        doTagClickStartButton();

        if (isButtonDisabled) {
            SECTION_FIELDS.forEach(fieldName => {
                if (!userProfile[fieldName]) {
                    formActions.setValidity(`userProfile.${fieldName}`, { required: '' });
                }
            });

            return;
        }
        doTagIsValidAndGoNext();
        handleValidateSection();
    };
    const handleModifyIDWithTagging = () => {
        handleModifyID();
        doTagModifyIdDocument();
    };

    const handleObscurePassword = useCallback(
        show => {
            userProfile.onboardingType !== undefined && doTagObscurePassword(show);
        },
        [userProfile.onboardingType]
    );

    return (
        <Section
            type={SECTION_TYPE.ACCESS_DATA}
            isCollapsed={isCollapsed}
            isValidated={isValidated}
            handleModifySection={handleModifySection}
            handleValidateSection={onValidationSection}
            isButtonDisabled={isButtonDisabled}
            userProfile={userProfile}
            promoCode={promoCode}
        >
            <PersonalDataSummary
                documentType={documentType}
                docNumber={docNumber}
                handleModifyID={handleModifyIDWithTagging}
            />
            <Password
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                formActions={formActions}
                setIsValidPass={setIsValidPass}
                onFocus={doTagPassword}
                onObscurePasswordChange={handleObscurePassword}
                resetDependencies={[userProfile.onboardingType]}
                onCustomError={doTagPasswordErrors}
            />

            {renderTermsAndConditions()}
        </Section>
    );
};
